import * as React from 'react';

// Components
import { InputUsername, InputPhone, InputEmail } from '@shopee-user/input';

// Hooks
import { useTranslation, config } from '@shopee-user/platform';

// Utils
import { isFeatureEnabled } from '@shopee-user/business-customization-logic';

// Enums
import { Feature } from '@shopee-user/feature-toggle';

// Types
import { InputProps } from '@shopee-user/input';

export const MAX_LOGIN_KEY_LENGTH = 128;

function InputAuthKey(props: InputProps) {
  const I18n = useTranslation();
  const isPhoneAllowed = isFeatureEnabled(Feature.LoginByPasswordAllowPhone);
  const isEmailAllowed = isFeatureEnabled(Feature.LoginByPasswordAllowEmail);
  if (isPhoneAllowed && isEmailAllowed) {
    return (
      <InputUsername
        type="text"
        placeholder={I18n.t('label_auth_phone_number_or_email_placeholder', {
          context: config.LOCALE.toLocaleLowerCase(),
        })}
        maxLength={MAX_LOGIN_KEY_LENGTH}
        autoComplete="on"
        showErrorOutline
        showError
        autoFocus
        {...props}
      />
    );
  } else if (isEmailAllowed) {
    return (
      <InputEmail
        type="text"
        placeholder={I18n.t('label_auth_email_placeholder', {
          context: config.LOCALE.toLocaleLowerCase(),
        })}
        maxLength={MAX_LOGIN_KEY_LENGTH}
        autoComplete="on"
        showErrorOutline
        showError
        autoFocus
        {...props}
      />
    );
  } else {
    return (
      <InputPhone
        placeholder={I18n.t('label_auth_phone_number_placeholder', {
          context: config.LOCALE.toLocaleLowerCase(),
        })}
        maxLength={MAX_LOGIN_KEY_LENGTH}
        autoComplete="on"
        showErrorOutline
        showError
        autoFocus
        {...props}
      />
    );
  }
}

export default InputAuthKey;
